module.exports = new Promise((resolve, reject) => {
      if (!window.__REMOTES__) return reject(new Error('__REMOTES__ not initialized'));
      var url = window.__REMOTES__['subscriptions'];
      if (!url) return reject(new Error('No remote URL for subscriptions'));
      if (window['subscriptions']) return resolve(window['subscriptions']);
      var script = document.createElement('script');
      script.src = url;
      script.onload = function() { resolve(window['subscriptions']); };
      script.onerror = function() { reject(new Error('Failed to load ' + url)); };
      document.head.appendChild(script);
    });